import styled from "styled-components";
import { Headline, Paragraph } from "../../../components/styled/Text";

const InfoBlockContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  max-width: 600px;
  margin: 0 auto;
  width: 100%;
`;

const InfoBlockHeadline = styled(Headline)`
  font-size: 34px;
`;

const InfoBlock = ({ snapshotId }: { snapshotId: string }) => {
  return (
    <InfoBlockContainer>
      <InfoBlockHeadline textAlign="center">
        Processing your request
      </InfoBlockHeadline>
      <Paragraph textAlign="center">
        Your snapshot ID is: <strong>{snapshotId}</strong>
      </Paragraph>
      <Paragraph textAlign="center" marginTop="15px">
        While your snapshot is processing. We recommend minting your new
        Lossless protected token <strong>first.</strong> Using our{" "}
        <a href="https://minter.lossless.cash" target="_blank" rel="noreferrer">
          <strong>Token Minter</strong>
        </a>
      </Paragraph>
    </InfoBlockContainer>
  );
};

export default InfoBlock;
